// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"3b83f714","592":"d992a281","677":"52939e84","694":"e14c439a","778":"818c6e7b"}[chunkId] + ".chunk.js";
};